<!-- 
    COMPONENT CARD
-->


<!---------- SCRIPT ---------->

<script lang="ts">
    
    import type { Card } from "../models/card";
    import { deglingos, minitel, english } from '../store/store'

    export let card: Card;

</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">
    .card {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        align-content: center;
        background-color: $color_primary;
        color: $color_secondary;
        border: 1px solid $color_secondary;
        box-shadow: 8px 8px 8px $color_black;
        transition: background-color 1s linear;
        width: 200px;
        height: 200px;
        border-radius: 8px;
        margin: 8px 8px 8px 8px;
        &:hover {
            background-color: $color_secondary;
            color: $color_primary;
            border: 1px solid $color_primary;
            box-shadow: 8px 8px 8px $color_primary;
        }
        &__front {
            display: block;
            text-align: center;
        }
        &__back {
            display: none;
            text-align: center;
        }
        &:hover &__back {
            display: block;
        }
        &:hover &__front {
            display: none;
        }
        &__h1 {
            padding: 0 8px 0 8px;
            font-size: 1.1em;
            text-shadow: none;
        }
        &__p {
            padding: 0 8px 0 8px;
            text-shadow: none;
        }
        &__click {
            display: block;
            font-size: x-small;
            &__deglingos {
                text-shadow: none;
            }
        }
    }

    .cardMinitel {
        display: flex;
        flex-direction: column;
        color: $color_minitel_green;
        width: 100%;
        &__front {
            color: $color_minitel_blue;
        }
        &__back {
            color: $color_white;
        }
        &__click {
            display: none;
        }
        &__h1 {
            color: $color_minitel_blue;
        }
        &__p {
            text-decoration: underline dotted;
        }
    }


    @include large {
        .card {
            &__click {
                display: none;
            }
        }
        .cardMinitel {
            flex-direction: row;
            &__front {
                min-width: 300px;
            }
        }
    }

</style>
  
  
<!---------- TEMPLATE ---------->

<div class:card={!$minitel} class:cardMinitel={$minitel}>
    <div class:card__front={!$minitel} class:cardMinitel__front={$minitel}>
        <h1 class:card__h1={!$minitel} class:cardMinitel__h1={$minitel}>{card.title}</h1>
        {#if $english}
            <p class:card__click={!$minitel} class:card__click__deglingos={$deglingos} class:cardMinitel__click={$minitel}>more ...</p>
        {:else}
            <p class:card__click={!$minitel} class:card__click__deglingos={$deglingos} class:cardMinitel__click={$minitel}>plus d'infos ...</p>
        {/if}
    </div>
    <div class:card__back={!$minitel} class:cardMinitel__back={$minitel}>
        {#each card.description as desc}
            <p class:card__p={!$minitel} class:cardMinitel__p={$minitel}>{desc}</p>
        {/each}
    </div>
</div>